import { initReactI18next } from "react-i18next";

import i18n from "i18next";
// import detector from "i18next-browser-languagedetector";

import translationDe from "./locales/de/translation.json";
import translationENG from "./locales/eng/translation.json";

// the translations
const resources: any = {
  de: {
    translation: translationDe,
  },
  en: {
    translation: translationENG,
  },
};

const language: any = localStorage.getItem("I18N_LANGUAGE");
if (!language) {
  localStorage.setItem("I18N_LANGUAGE", "en");
}

i18n
  // .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem("I18N_LANGUAGE") || "en",
    fallbackLng: "en",
    keySeparator: ".",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
